import { Alert, Button, Modal } from "@toddle-edu/ds-web";
import React, { useState } from "react";
import { useI18n } from "Hooks";
import { Trans } from "react-i18next";
import classes from "./DeleteTagModal.scss";

const DeleteTagModal = props => {
  const { onClose, title, onDeleteTag } = props;
  const { t } = useI18n();
  const [isAlertChecked, setIsAlertChecked] = useState(false);

  return (
    <Modal width="440px" height="412px" onClose={onClose}>
      <Modal.Header
        isClosable
        title={t("common:delete_with_forward_quote_label", { label: title })}
      ></Modal.Header>
      <Modal.Body>
        <div>
          <div>
            {t("scopeAndSequence:please_acknowledge_title_before_deleting", {
              label: title,
            })}
          </div>
          <div className={classes.alertContainer}>
            <Alert
              type="error"
              message=<Trans
                i18nKey={
                  "scopeAndSequence:deleting_tag_will_also_delete_from_standards"
                }
              >
                I understand that deleting this tag will also{" "}
                <b>delete it from all the standards</b> it is currently tagged
                to <b>across my school.</b>
              </Trans>
              onChange={e => setIsAlertChecked(e.target.checked)}
            />
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className={classes.buttonContianer}>
          <Button onClick={onClose} variant="outlined-subtle" size="large">
            {t("common:cancel")}
          </Button>
          <Button
            onClick={onDeleteTag}
            variant="primary"
            size="large"
            disabled={!isAlertChecked}
          >
            {t("common:delete")}
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteTagModal;
